import { Button } from "@svea/design-system-components-react";
import {
	type AnsweredQuestion,
	type AnyQuestion,
	ButtonGroup,
	getQuestionnaireInitialValues,
	parseFormValues,
	Question,
	type QuestionnaireFormValues,
	Stack,
	useText,
} from "@sveabank/cc-common";
import { Form } from "react-final-form";
import { usePageContext } from "../../../../hooks/context";
import type {
	ClcProductDefinitionId,
	ClcProductQuestionSet,
} from "../../../../types/clc-application";
import { useClcCompanyApplication } from "../../hooks";

const trackingNameMap: Partial<Record<ClcProductDefinitionId, string>> = {
	TRANSAKTIONSKONTO: "Transaction Account",
	SPARKONTO: "Savings Account",
	BANKCERTIFICATE: "Share Capital",
};

type Props = {
	onSubmit: (productId: string, questions: AnsweredQuestion[]) => Promise<void>;
	questionSet: ClcProductQuestionSet;
	onCancel: () => void;
};

const ClcAmlQuestions = ({ onSubmit, questionSet, onCancel }: Props) => {
	const { sortedCountries } = usePageContext(useClcCompanyApplication);
	const { questions, productId } = questionSet;
	const submitAnswers = async (
		productId: string,
		questions: Array<AnyQuestion>,
		values: QuestionnaireFormValues,
	) => onSubmit(productId, parseFormValues(questions, values));

	const initialValues = getQuestionnaireInitialValues(questions);

	const [t, texts] = useText();

	return (
		<Form<QuestionnaireFormValues>
			onSubmit={(values) => {
				return submitAnswers(productId, questions, values);
			}}
			initialValues={initialValues}
			render={({ handleSubmit, submitting }) => (
				<form onSubmit={handleSubmit}>
					<Stack gap={6}>
						{questions.map((q) => (
							<Question question={q} key={q.questionId} allCountries={sortedCountries} />
						))}
						<ButtonGroup row align="start">
							<Button type="button" variant="secondary" onPress={onCancel}>
								{t(texts.common.abort)}
							</Button>
							<Button
								type="submit"
								isPending={submitting}
								data-tracking-action="CLC Application Continue"
								data-tracking-name={`${trackingNameMap[questionSet.productDefinitionId]} AML Questions`}
							>
								{t(texts.common.save)}
							</Button>
						</ButtonGroup>
					</Stack>
				</form>
			)}
		/>
	);
};

export default ClcAmlQuestions;
